import { GlobalConfigType } from 'actions'
import cloneDeep from 'clone-deep'
import { LayoutLoading } from 'components/LayoutLoading'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { partiesMap } from 'reducers/loanDetail.reducer'
import { getBorrowerInfo } from 'services'

import { EmailParty, EmailTo, EmailValue } from './EmailTo'

export const LoanPartiesEmailTo = ({
  loanNumber = 0,
  value,
  data: _data,
  loadParties = false,
  hasAddEmail = true,
  hasUniqueToEmail = false,
  onChange,
}: {
  loanNumber?: number
  value: EmailValue
  data: EmailParty[]
  loadParties?: boolean
  hasAddEmail?: boolean
  hasUniqueToEmail?: boolean
  onChange: (data: EmailValue) => void
}) => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState<EmailParty[]>(_data)
  const [isLoaded, setLoaded] = useState(false)

  const { auth, loanDetail, globalSettingV2 } = useSelector((state: any) => {
    return {
      auth: state.auth,
      loanDetail: state.loanDetail,
      globalSettingV2: state.globalConfigReducer[GlobalConfigType.GlobalSettingV2],
    }
  })
  const accountType = auth.profile.isBorrower ? 'borrower' : auth.profile.accountType
  const { parties } = loanDetail
  useEffect(() => {
    setLoaded(false)
  }, [loanNumber])

  useEffect(() => {
    if (isLoaded || loading) return
    if (!loadParties) {
      setData(_data)
      return
    }

    setLoading(true)
    getBorrowerInfo(loanNumber)
      .then(async ({ parties, borrowerEmail, coBorrowerEmail, emailContacts }) => {
        const emails: EmailParty[] = cloneDeep(_data)
        if (borrowerEmail)
          emails.push({
            party: 'Borrower',
            email: borrowerEmail,
          })
        if (coBorrowerEmail)
          emails.push({
            party: 'CoBorrower',
            email: coBorrowerEmail,
          })
        Object.keys(parties).forEach((key) => {
          // if (key == 'accountManager') return
          let email = parties[key]
          if (!email) return

          emails.push({
            party: partiesMap[key],
            email,
          })
        })
        emails.push(
          ...emailContacts.map((email: string) => ({
            party: 'E-Mail Notification Contacts',
            email,
          })),
        )

        globalSettingV2.partyView[accountType]
          .filter((key: string) => !Object.keys(parties).includes(key))
          .map((key: string) => {
            const closeParty = loanDetail.closeParties[key]
            if (!closeParty || !closeParty.EMail) return
            emails.push({
              party: closeParty.CustomName || closeParty.Type,
              email: closeParty.EMail,
            })
          })
        setData(emails)
      })
      .finally(() => {
        setLoading(false)
        setLoaded(true)
      })
  }, [loadParties, _data, parties])

  return (
    <div>
      <LayoutLoading show={loading} />
      <div className="mb-5"></div>
      <EmailTo
        Emails={value}
        Data={data}
        onChange={(data: EmailValue) => onChange(data)}
        hasAddEmail={hasAddEmail}
        hasUniqueToEmail={hasUniqueToEmail}
      />
    </div>
  )
}
